/**
 *
 * Asynchronously loads the component for UploadLogsPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const UploadLogsPage = lazyLoad(
  () => import("./index"),
  module => module.UploadLogsPage,
)
